<script setup lang="ts">
import { ModalsContainer } from 'vue-final-modal'
import Toast from '~/components/Toast.vue'
</script>

<template>
    <NuxtLayout>
        <NuxtPage />
        <ModalsContainer />
        <Toast />
    </NuxtLayout>
</template>

<style>
/* Global styles for the app */
html,
body {
    font-family: var(--font-body), sans-serif;
    background-color: var(--color-bg-primary-light);
}

/* Explicit dark mode background to avoid CSS layer cascade issues */
html[data-theme='dark'],
html[data-theme='dark'] body {
    background-color: var(--color-bg-primary-dark);
}

/* Custom scrollbar styles */
::-webkit-scrollbar {
    width: 1px;
    height: 1px;
}
</style>
